import { FunctionComponent, useEffect, useState } from 'react';
import { Descriptions, DescriptionsProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'stores/store';

// styles
import styles from './actions.module.scss';
import { ServiceCost } from './commonModels';

interface ActionCostComponentProps {
	serviceCost: ServiceCost;
}

const ActionCostComponent: FunctionComponent<ActionCostComponentProps> = ({ serviceCost }) => {
	const { t, i18n } = useTranslation();

	const [items, setItems] = useState<DescriptionsProps['items']>([]);

	useEffect(() => {
		const tempItems: DescriptionsProps['items'] = [];
		const remainingTransactions = serviceCost?.payment_details.usage_remaining_after + serviceCost?.payment_details.usage_required;

		tempItems.push({
			key: 1,
			label: t('ACTIONS.COST'),
			children: (
				<p style={{ color: serviceCost?.can_access ? '#28a728' : 'red' }}>
					{`${
						serviceCost?.can_access
							? serviceCost?.payment_method == 'usage'
								? serviceCost?.payment_details.usage_required
								: serviceCost?.payment_method == 'points'
								? serviceCost?.payment_details.points_required
								: serviceCost?.payment_method == 'free'
								? t('COMMON.FREE_PRICE')
								: serviceCost?.payment_method == 'combined'
								? serviceCost?.cost_breakdown?.combined_payment.final_cost
								: ''
							: serviceCost?.cost_breakdown?.original_cost
					} ${
						serviceCost?.payment_method !== 'free' ? (serviceCost?.payment_method == 'usage' ? t('ACTIONS.TRANSACTION') : t('COMMON.POINTS')) : ''
					}`}
				</p>
			),
		});

		serviceCost?.payment_method !== 'free' &&
			tempItems.push({
				key: 2,
				label: t('ACTIONS.BALANCE'),
				children: (
					<p style={{ color: serviceCost?.can_access ? '#28a728' : 'red' }}>
						{serviceCost?.payment_method == 'usage'
							? `${remainingTransactions} ${remainingTransactions === 1 ? t('ACTIONS.TRANSACTION') : t('ACTIONS.TRANSACTIONS')}`
							: `${Number(serviceCost?.payment_details?.wallet_balance ?? 0).toLocaleString('en-US')} ${t('COMMON.POINTS')}`}
					</p>
				),
			});

		setItems(tempItems);
	}, [serviceCost, i18n.language]);

	return <Descriptions bordered items={items} size="small" column={1} className={styles.cost} />;
};

export default ActionCostComponent;
